import { render, staticRenderFns } from "./LoginBoard.vue?vue&type=template&id=f31ff840&scoped=true"
import script from "./LoginBoard.vue?vue&type=script&lang=js"
export * from "./LoginBoard.vue?vue&type=script&lang=js"
import style0 from "./LoginBoard.vue?vue&type=style&index=0&id=f31ff840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31ff840",
  null
  
)

export default component.exports